import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {ServiziSpontanei} from "../models/personal-area/institutiton-categories/servizi-spontanei.model";
import { HttpClient } from "@angular/common/http";
import {PathStore} from "../store/path.store";
import {ProfileDataPopupFunzionalitaEstese, UserProfile} from "../models/personal-area/user/user-profile";

@Injectable({
  providedIn: 'root'
})
export class UserService {

  public userProfile: UserProfile | null = null;
  // [x]: PAF - functionality
  public userPagamentoVeloceFunctionality: boolean = false;
  public userAreaEstesaFunctionality: boolean = false;

  constructor(private http: HttpClient, private path: PathStore) {}

  deleteProfileAndPersonalArea(): Observable<void> {
    return this.http.delete<void>(`${this.path.baseURLPosizioni}/posizioniservice/areapersonale/delete`);
  }
  getUserProfile(codiceFiscale: string, codiceIpaEnte: string): Observable<UserProfile> {
    const url = `${this.path.userProfileUrl}/${codiceFiscale}/${codiceIpaEnte}`;
    return this.http.get<UserProfile>(url);
  }
  putUserProfile(userProfile: UserProfile): Observable<UserProfile> {
    const url = `${this.path.userProfileUrl}/userprofiles`;
    return this.http.put<UserProfile>(url, userProfile);
  }
  setUserAccess(userProfile: UserProfile): Observable<UserProfile> {
    const url = `${this.path.userProfileUrl}/useraccess`;
    return this.http.post<UserProfile>(url, userProfile);
  }
  checkRecaptchaToken(token: any): Observable<any> {
    const url = `${this.path.service}/recaptcha`;
    return this.http.post<any>(url, token);
  }
  // [x]: PAF - get
  getUserExtendedFunctionality(userProfile: UserProfile): Observable<ProfileDataPopupFunzionalitaEstese> {
    const url = `${this.path.posizioniServiceUrl}/getprofiledatapopufunzionalitestese/${userProfile.codiceFiscale}/${userProfile.codiceIpaEnte}`;
    return this.http.get<ProfileDataPopupFunzionalitaEstese>(url);
  }
  // [x]: PAF - put
  setUserExtendedFunctionality(userProfile: UserProfile): Observable<UserProfile> {
    const url = `${this.path.posizioniServiceUrl}/setprofiledatapopufunzionalitestese/${userProfile.codiceFiscale}/${userProfile.codiceIpaEnte}`;
    return this.http.put<UserProfile>(url, userProfile);
  }
}
